/** The tone a sub-agent's execution status renders in. */
type TaskStatusTone = "completed" | "partial" | "timeout" | "cancelled" | "error" | "running";

/**
 * taskStatusTone maps the status a sub-agent reports to the pill its card
 * renders. The values come from the agent executor: "completed", "partial" for
 * an answer given after being told to wrap up, every stop reason it can halt
 * on, and the execution-error reason. A status it doesn't write — including the
 * "running" a card synthesizes while the result is still arriving — keeps the
 * in-flight pill.
 *
 * "cancelled" gets its own pill even though the executor files it under the
 * execution-error reason: the main agent cancels the sub-agents still running
 * when it answers, which is routine, not a failure.
 */
export function taskStatusTone(status: string): TaskStatusTone {
  switch (status) {
    case "completed":
      return "completed";
    case "timeout":
      return "timeout";
    // Stopped short of a full answer, with whatever work it had done.
    case "partial":
    case "max_turns_exceeded":
    case "max_tool_calls_exceeded":
    case "context_exceeded":
      return "partial";
    case "cancelled":
      return "cancelled";
    case "error":
    case "execution_error":
      return "error";
    default:
      return "running";
  }
}
